/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebAuthnResidentKey = {
    Discouraged: 'discouraged',
    Preferred: 'preferred',
    Required: 'required'
} as const;
export type WebAuthnResidentKey = typeof WebAuthnResidentKey[keyof typeof WebAuthnResidentKey];


export function instanceOfWebAuthnResidentKey(value: any): boolean {
    for (const key in WebAuthnResidentKey) {
        if (Object.prototype.hasOwnProperty.call(WebAuthnResidentKey, key)) {
            if (WebAuthnResidentKey[key as keyof typeof WebAuthnResidentKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebAuthnResidentKeyFromJSON(json: any): WebAuthnResidentKey {
    return WebAuthnResidentKeyFromJSONTyped(json, false);
}

export function WebAuthnResidentKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnResidentKey {
    return json as WebAuthnResidentKey;
}

export function WebAuthnResidentKeyToJSON(value?: WebAuthnResidentKey | null): any {
    return value as any;
}

export function WebAuthnResidentKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): WebAuthnResidentKey {
    return value as WebAuthnResidentKey;
}

